import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { teachingMethod } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';
export function SolutionSection() {
  return <section aria-labelledby="solution-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-166" data-mp="1jpfupihtx39i">
      <div className="mx-auto max-w-5xl" data-id="element-167" data-mp="1ohg2ty81z2h6">
        <SectionHeading id="solution-heading" title={<>
              Voici Nail Educator Ready™ — <Accent data-id="element-169" data-mp="1yelw9d4535kk">Édition Française</Accent>
            </>} body="Le système créé pour aider les formatrices ongulaires à passer de « Je sais le faire » à « Je sais comment l’enseigner »." data-id="element-168" data-mp="1oiiu479af6xm" />

        <img src={MOCKUP_URL} alt="Le système complet Nail Educator Ready" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block w-full max-w-[560px] object-contain lg:max-w-[780px]" style={{
        filter: 'drop-shadow(0 30px 36px rgba(120, 96, 56, 0.22))'
      }} data-id="element-170" data-mp="27fk09vekvd35" />

        <ol className="mx-auto mt-10 flex max-w-3xl flex-wrap items-center justify-center gap-x-2 gap-y-3 sm:gap-x-3" role="list" aria-label="La méthode" data-id="element-171" data-mp="3s1e3okgv3o7u">
          {teachingMethod.map((step, index) => <li key={step} className="flex items-center gap-2 sm:gap-3" data-id="element-172" data-mp="3i4hs25vo2lz2" data-mpi={index}>
              {index > 0 && <span aria-hidden="true" className="font-display text-[1.4rem] text-brand-gold" data-id="element-173" data-mp="jksrkusxof0i">
                  →
                </span>}
              <span className="rounded-full border border-brand-gold/40 bg-white px-4 py-2 font-body text-[12px] font-bold uppercase tracking-[0.14em] text-brand-charcoal sm:text-[13px]" data-id="element-174" data-mp="9mlmb980blec">
                {step}
              </span>
            </li>)}
        </ol>

        <p className="mx-auto mt-10 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-175" data-mp="2uazo0vtdkn39">
          Nail Educator Ready™ rassemble la structure pédagogique et technique dont vous avez besoin pour
          enseigner avec davantage de <strong className="font-semibold text-brand-charcoal" data-id="element-176" data-mp="1lf4302kv6i1f">clarté, de cohérence et de confiance</strong> — sans
          créer chaque ressource à partir de zéro.
        </p>
      </div>
    </section>;
}